import { createSlice } from "@reduxjs/toolkit";

export const mockDiscoveredSiteDevices = [
  {
    "alertReport": 1,
    "brandName": "D-Link Corporation",
    "datetime": "20010301163609",
    "defaultGateway": "0.0.0.0",
    "defaultGatewayIPv6Address": "::",
    "deviceIPAddress": "192.168.220.144",
    "deviceIPType": 2,
    "deviceIPv6Address": "::",
    "deviceIPv6Prefix": 0,
    "dhcpEnable": 0,
    "dhcpv6State": 0,
    "dstEffectiveDuration": 0,
    "dstOffset": 0,
    "dstState": 0,
    "dstSupport": 1,
    "hardwareVersion": "A1",
    "ipStatus": 0,
    "layer": 2,
    "macAddress": "3c:33:32:14:ab:00",
    "managedByNMS": 0,
    "mgmtMode": "Unknown",
    "mgmtStatus": 0,
    "modelName": "DGS-1530-52",
    "portInterfaceNumber": "Port 9",
    "primaryDNS": "0.0.0.0",
    "primaryDnsIPv6Address": "::",
    "productCategory": "Switch",
    "productHWSpecification": 16777216,
    "productName": "DGS-1530-52",
    "protocolType": "snmp",
    "secondaryDNS": "0.0.0.0",
    "secondaryDnsIPv6Address": "::",
    "serialNumber": "UH2D146000002",
    "subnetMask": "255.255.255.0",
    "systemName": "DGS-1530-52",
    "timezone": 7424,
    "version": "1.00.032",
    "webPortNumber": 80
  },
  {
    "agentGroupUUID": "F911-D3903439-11EFAA28-A1AD",
    "alertReport": 0,
    "brandName": "D-Link Corporation Inc.",
    "datetime": "20240928192156",
    "defaultGateway": "0.0.0.0",
    "defaultGatewayIPv6Address": "::",
    "deviceIPAddress": "192.168.10.197",
    "deviceIPType": 0,
    "deviceIPv6Address": "0:0:100::",
    "deviceIPv6Prefix": 0,
    "dhcpEnable": 1,
    "dhcpv6State": 0,
    "dstEffectiveDuration": 0,
    "dstOffset": 0,
    "dstState": 0,
    "dstSupport": 1,
    "hardwareVersion": "A1",
    "ipStatus": 1,
    "layer": 2,
    "macAddress": "bc:22:28:d7:64:80",
    "managedByNMS": 1,
    "mgmtMode": "Unknown",
    "mgmtStatus": 0,
    "modelName": "DMS-3130-30PS",
    "nmsURL": "192.168.220.76:9002",
    "portInterfaceNumber": "1/0/1",
    "primaryDNS": "192.168.10.254",
    "productCategory": "Switch",
    "productHWSpecification": 134217728,
    "productName": "DMS-3130-30PS",
    "protocolType": "unity",
    "secondaryDNS": "0.0.0.0",
    "serialNumber": "TM81121000011",
    "subnetMask": "255.255.255.0",
    "systemName": "Switch",
    "timezone": 0,
    "version": "1.20.003",
    "webPortNumber": 80
  },
  {
    "agentGroupUUID": "F911-D3903439-11EFAA28-A1AD",
    "alertReport": 0,
    "datetime": "20000107161329",
    "defaultGateway": "192.168.10.254",
    "defaultGatewayIPv6Address": "::",
    "deviceIPAddress": "192.168.10.58",
    "deviceIPType": 0,
    "deviceIPv6Address": "::",
    "deviceIPv6Prefix": 0,
    "dhcpEnable": 1,
    "dhcpv6State": 0,
    "dstEffectiveDuration": 0,
    "dstOffset": 0,
    "dstState": 0,
    "dstSupport": 1,
    "hardwareVersion": "A3",
    "ipStatus": 1,
    "layer": 2,
    "macAddress": "00:25:35:89:22:01",
    "managedByNMS": 2,
    "mgmtMode": "Unknown",
    "mgmtStatus": 0,
    "modelName": "DGS-1100-18PV2",
    "nmsURL": "192.168.10.76:9001",
    "portInterfaceNumber": "Port 1",
    "primaryDNS": "0.0.0.0",
    "primaryDnsIPv6Address": "::",
    "productCategory": "Switch",
    "productHWSpecification": 0,
    "protocolType": "nc",
    "secondaryDNS": "0.0.0.0",
    "secondaryDnsIPv6Address": "::",
    "serialNumber": "04",
    "subnetMask": "255.255.255.0",
    "systemName": "SWITCH",
    "timezone": 2048,
    "version": "V4.00.019",
    "webPortNumber": 80
  },
  {
    "alertReport": 1,
    "brandName": "D-Link Corporation",
    "datetime": "20010301163803",
    "defaultGateway": "0.0.0.0",
    "defaultGatewayIPv6Address": "::",
    "deviceIPAddress": "192.168.220.143",
    "deviceIPType": 2,
    "deviceIPv6Address": "::",
    "deviceIPv6Prefix": 0,
    "dhcpEnable": 0,
    "dhcpv6State": 0,
    "dstEffectiveDuration": 0,
    "dstOffset": 0,
    "dstState": 0,
    "dstSupport": 1,
    "hardwareVersion": "A1",
    "ipStatus": 0,
    "layer": 2,
    "macAddress": "3c:33:32:14:a2:00",
    "managedByNMS": 0,
    "mgmtMode": "Unknown",
    "mgmtStatus": 0,
    "modelName": "DGS-1530-28SC",
    "portInterfaceNumber": "Port 87",
    "primaryDNS": "0.0.0.0",
    "primaryDnsIPv6Address": "::",
    "productCategory": "Switch",
    "productHWSpecification": 16777216,
    "productName": "DGS-1530-28SC",
    "protocolType": "snmp",
    "secondaryDNS": "0.0.0.0",
    "secondaryDnsIPv6Address": "::",
    "serialNumber": "UH2C146000001",
    "subnetMask": "255.255.255.0",
    "systemName": "DGS-1530-28SC",
    "timezone": 7424,
    "version": "1.00.032",
    "webPortNumber": 80
  },
  {
    "agentGroupUUID": "F911-D3903439-11EFAA28-A1AD",
    "alertReport": 0,
    "brandName": "D-LINK",
    "datetime": "20230122085906",
    "defaultGateway": "192.168.10.254",
    "defaultGatewayIPv6Address": "::",
    "deviceIPAddress": "192.168.10.168",
    "deviceIPv6Address": "::",
    "deviceIPv6Prefix": 0,
    "dhcpEnable": 1,
    "dhcpv6State": 0,
    "dstEffectiveDuration": 0,
    "dstOffset": 0,
    "dstState": 0,
    "dstSupport": 1,
    "hardwareVersion": "A1",
    "layer": 2,
    "macAddress": "bc:22:28:72:0f:70",
    "managedByNMS": 0,
    "mgmtMode": "Unknown",
    "mgmtStatus": 0,
    "modelName": "DAP-X2810",
    "nmsURL": "192.168.10.76:9001",
    "portInterfaceNumber": "LAN1",
    "primaryDNS": "192.168.10.254",
    "primaryDnsIPv6Address": "::",
    "productCategory": "Access point",
    "productHWSpecification": 0,
    "productName": "D-LINK AP",
    "protocolType": "nc",
    "secondaryDNS": "0.0.0.0",
    "secondaryDnsIPv6Address": "::",
    "serialNumber": "",
    "subnetMask": "255.255.255.0",
    "systemName": "dapx2810",
    "timezone": 2048,
    "version": "1.20",
    "webPortNumber": 80
  }
];

export const discoveredSiteSlice = createSlice({
  name: "onPremDiscoveredOrgDevices",
  initialState: {
    resource: "discovery",
    data: [...mockDiscoveredSiteDevices],
  },
});

export default discoveredSiteSlice.reducer;